import { VeroxCountdownApiClient } from '@kadima-tech/verox-countdown-sdk';

export const apiClient = new VeroxCountdownApiClient();
